import React, { Fragment, useState } from 'react';
import { useFormContext } from 'react-hook-form';
import { Grid, FormControlLabel, Checkbox } from '@material-ui/core';
import { useStyle } from './style';
import { TERMS_AND_CONDITIONS_LINK } from './constants';
import errormesages from './errormessages';

export const EirTermsNConditions = () => {
    const classes = useStyle();
    const [termsAndConditions, setTermsAndConditions] = useState(false);
    const { register, errors, setError, clearError } = useFormContext();
    const { validation } = errormesages;


    const handleChange = (event) => {

        setTermsAndConditions(event.target.checked);

        if (!event.target.checked) {
            setError('termsAndConditions');
        }
        else {
            clearError('termsAndConditions');
        }
        return event.target.value;
    };

    return (
        <Fragment>
            <h4 className={classes.margintop}>eir Terms and Conditions</h4>
            <Grid container spacing={4}>
                <Grid item xs={12}>
                    <FormControlLabel
                        control={
                            <Checkbox
                                checked={termsAndConditions}
                                color="primary"
                                id="termsAndConditions"
                                name="termsAndConditions"
                                onChange={(event) => handleChange(event)}
                                inputRef={register}
                            />
                        }
                        label={(
                            <span>
                                I understand and agree to the
                                <a href={TERMS_AND_CONDITIONS_LINK} rel="noopener noreferrer" target="_blank"> eir mobile terms and conditions.</a>
                            </span>
                        )
                        }
                    />
                    {errors.termsAndConditions && <span className={classes.errorMessage}>{validation.termsNconditionsRequired}</span>}
                </Grid>
            </Grid>
        </Fragment>
    );
}